import axios from 'axios';

// Configuración global de Axios
axios.defaults.timeout = 30000; // 30 segundos
axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;

// Interceptor para las peticiones
axios.interceptors.request.use(
  (config) => {
    // Añadir headers comunes si es necesario
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para las respuestas
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.code === 'ECONNABORTED') {
      console.error('La petición ha excedido el tiempo de espera');
    }
    return Promise.reject(error);
  }
);

export default axios;